var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInputIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.28571429,6.42857143 L9.28571429,8.85714286 L4.42857143,8.85714286 L4.42857143,12.5 L9.28571429,12.5 L9.28571429,14.9285714 L3,14.9285714 C2.44771525,14.9285714 2,14.4808562 2,13.9285714 L2,7.42857143 C2,6.87628668 2.44771525,6.42857143 3,6.42857143 L9.28571429,6.42857143 Z M14.1428571,6.42857143 L18,6.42857143 C18.5522847,6.42857143 19,6.87628668 19,7.42857143 L19,13.9285714 C19,14.4808562 18.5522847,14.9285714 18,14.9285714 L14.1428571,14.9285714 L14.1428571,12.5 L16.5714286,12.5 L16.5714286,8.85714286 L14.1428571,8.85714286 L14.1428571,6.42857143 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 10.5,
  y: 4,
  width: 2.42857143,
  height: 12.1428571,
  rx: 1
}))));
export default SvgInputIcon;